module.exports = __webpack_public_path__ + "img/about_us_bg.8e1a2bf.webp";